import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {DistanceReferenceProps} from './types';

export function DistanceReference({distance, distanceDescription}: DistanceReferenceProps) {
	const theme = useTheme();

	if (!distance) return null;

	return (
		<Stack direction="row" gap={0.5} alignItems={'center'}>
			<Stack minWidth={20}>
				<Icon name={'location-on-filled'} size={16} color={theme.palette.primary.main} />
			</Stack>
			<Typography variant="body2" color="text.secondary">
				{distance?.toFixed(1)} km {distanceDescription}
			</Typography>
		</Stack>
	);
}
